import { ShieldCheck } from "lucide-react";
import { Reveal } from "./shared";

export function EnterpriseSecurity() {
  return (
    <section id="security" aria-labelledby="security-heading" className="scroll-mt-20 border-t border-border bg-background">
      <div className="mx-auto flex max-w-7xl flex-col gap-14 px-4 py-24 sm:px-6 md:gap-20 md:py-32">
        <Reveal className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16">
          <div className="flex flex-col gap-5 lg:col-span-5">
            <p className="inline-flex items-center gap-2 self-start rounded-lg border border-border/70 bg-card/60 px-3 py-2 text-xs font-semibold uppercase tracking-widest text-foreground shadow-sm backdrop-blur-md">
              <ShieldCheck aria-hidden="true" className="size-4 text-muted-foreground" />
              Data &amp; security
            </p>
            <h2
              id="security-heading"
              className="font-heading text-4xl font-semibold leading-[1.05] tracking-tighter text-foreground text-balance sm:text-5xl"
            >
              Your Brand. Your Product. Your Data.
            </h2>
            <p className="text-lg leading-relaxed text-muted-foreground text-pretty">
              Your brand stays at the forefront. Your products remain yours. Your customer relationships and business
              data stay under your control.
            </p>
          </div>

          <div className="flex flex-col gap-6 text-base leading-relaxed text-muted-foreground lg:col-span-6 lg:col-start-7 lg:pt-10">
            <p className="text-pretty">
              We operate as the infrastructure behind the experience, supporting insurance, verification, risk
              management, and back-office services without stepping in front of your brand or taking ownership of your
              customer relationship.
            </p>
            <p className="text-pretty">
              Our strict data protection and access controls, limiting data use to what is required to deliver the services
              you choose. Partner data is treated as protected business infrastructure, not as a marketing asset or an
              opportunity to compete.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
